// extracted by mini-css-extract-plugin
module.exports = {"container":"qrb_1Cw3","label":"J9yCzQL7","labelContainer":"A1nls2P1","labelRoot":"TABP6SC0"};